import { callCurationProxy } from "../backend/backendClient";

/**
 * Delete list item by ID
 * @param itemId
 */
export const deleteListItem = async (itemId: number): Promise<void> => {
    if (!itemId) {
        throw new Error("deleteListItem requires an itemId.");
    }

    const res = await callCurationProxy({
        path: `/list/${itemId}`,
        method: "DELETE",
    });

    if (!res.ok) {
        const responseText = await res.text();
        throw new Error(`API Error on DELETE: ${res.status} - ${responseText}`);
    }
};
